"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = exports.TILES_ANIMATION_EVENT_NAMES = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _ArrayHelper = require("../../../helpers/ArrayHelper");

var TILES_ANIMATION_EVENT_NAMES = {
  animationDone: 'animationDone'
};
exports.TILES_ANIMATION_EVENT_NAMES = TILES_ANIMATION_EVENT_NAMES;

var TilesAnimationHelper = /*#__PURE__*/function () {
  function TilesAnimationHelper() {
    (0, _classCallCheck2["default"])(this, TilesAnimationHelper);
    this.listener = {};
    this.waitForNextEventListeners = {};
  }

  (0, _createClass2["default"])(TilesAnimationHelper, [{
    key: "addEventListener",
    value: function addEventListener(eventName, callback) {
      if (!this.listener[eventName]) {
        this.listener[eventName] = [];
      }

      if (!this.listener[eventName].includes(callback)) {
        this.listener[eventName].push(callback);
      }
    }
  }, {
    key: "fireEvent",
    value: function fireEvent(eventName) {
      if (this.listener[eventName]) {
        this.listener[eventName].forEach(function (callback) {
          // eslint-disable-next-line
          callback();
        });
      }
    }
  }, {
    key: "removeEventListener",
    value: function removeEventListener(eventName, callback) {
      if (this.listener[eventName]) {
        (0, _ArrayHelper.removeElement)(this.listener[eventName], callback);
      }
    }
  }, {
    key: "waitForNextEvent",
    value: function () {
      var _waitForNextEvent = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(eventName) {
        var _this = this;

        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", new _promise["default"](function (resolve, reject) {
                  var onNextEvent = function onNextEvent() {
                    _this.removeEventListener(eventName, onNextEvent);

                    resolve();
                  };

                  _this.addEventListener(eventName, onNextEvent);
                }));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function waitForNextEvent(_x) {
        return _waitForNextEvent.apply(this, arguments);
      }

      return waitForNextEvent;
    }()
  }]);
  return TilesAnimationHelper;
}();

var instance = new TilesAnimationHelper();
var _default = instance;
exports["default"] = _default;